
import React, { Component } from 'react';

import Header from 'parts/Header';
import Footer from 'parts/Footer';
import JobApplicationForm from 'parts/JobApplicationForm';
import JobApplyDetail from 'parts/JobApplyDetail';


export default class jobApply extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <>
        <Header />
        <JobApplyDetail />
        <Footer />
      </>
    );
  }
}
